<template>
    <el-dialog
            :title="dakatitle"
            :visible="showdkModel"
            :close-on-click-modal="!showdkModel"
            :before-close="close"
            width="600px"
    >
        <div class="Koicontent">
            <el-form ref="form" :model="DkModel" label-width="80px" :rules="rules">
                <el-form-item label="观点名称" prop="VideoName">
                    <el-input v-model.trim="DkModel.VideoName" maxlength="100" placeholder="请输入视频名称" class="edit_input" style="width: 410px"></el-input>
                </el-form-item>
                <el-form-item label="大咖封面" prop="VideoCoverImgUrl" class="mask">
                    <el-upload
                            :action="url"
                            list-type="picture-card"
                            accept=".jpg, .jpeg, .png,.gif,.bmp"
                            :file-list="fileList"
                            :limit="imgLimitNum"
                            :before-upload="beforeAvatarUpload"
                            :on-exceed="handlePicOutLimit"
                            :on-preview="handlePictureCardPreview"
                            :on-remove="handleRemove"
                            :on-success="successUpload"
                            :class="{hide:hideUpload}">
                        <i class="el-icon-plus"></i>
                    </el-upload>
                    <span class="tips">请上传gif、png、jpg、jpeg、bmp格式文件</span>
                </el-form-item>
                <el-form-item label="大咖视频" prop="VideoUrl" class="mask">
                    <el-upload class="avatar-uploader el-upload--text mt-20"  action :http-request="Upload"
                               :before-upload="beforeAvatarUpload2" :on-preview="handlePreview" :before-remove="beforeRemove"
                               :on-remove="handleRemove2" :on-success="handleSuccess" drag :file-list="fileList2"
                               accept=".mp4" :show-file-list="false">
                                 <span class="timeDom"
                                       v-if="DkModel.VideoUrl != '' && videoFlag == false && DkModel.VideoSecond != '0'"><img
                                         src="@/assets/video.png" alt="" class="videoIcon2"><b
                                         v-text="resultFormat(DkModel.VideoSecond)"></b></span>
                        <video v-if="DkModel.VideoUrl != '' && videoFlag == false"
                               :src="DkModel.VideoUrl" class="avatar" controls="controls">
                            您的浏览器不支持视频播放
                        </video>
                        <i  v-if="DkModel.VideoUrl == '' && videoFlag == false" class="el-icon-plus avatar-uploader-icon"></i>
                        <el-progress v-if="videoFlag == true" type="circle" :percentage="progress"
                                     style="margin-top: 10px"></el-progress>
                    </el-upload>
                    <el-button size="mini" type="danger" v-if="DkModel.VideoUrl"
                               @click="DkModel.VideoUrl='';DkModel.VideoSecond=0" style="margin-right: 20px">删除文件重新上传
                    </el-button>
                    <span class="tips">请上传MP4格式文件，文件大小不超过10G</span>
                </el-form-item>
            </el-form>
            <div class="dialog-footer" style="text-align: center;margin-top: 50px;" slot="footer">
                <el-button type="danger" v-if="DkModel.Id!=-1" @click="deleteVideo()">删除</el-button>
                <el-button type="primary" @click="push('form')">确认</el-button>
            </div>
        </div>
        <el-dialog :visible.sync="dialogVisible" :close-on-click-modal="false" :append-to-body="true">
            <img width="100%" :src="dialogImageUrl" alt="" />
        </el-dialog>
    </el-dialog>
</template>

<script>
    import {
        client,
        getFileNameUUID
    } from "@/utils/ali-oss"; //前面的ali-js文件内的两个封装函数
    import apiEnv from "@/service/apiEnv.js";
    import {setuploadVideo,deleteListVideo} from "@/service/run";
    export default {
        name: "dkPopup",
        props:{
            currentParam:{
                type:Object,
                default(){return {}}
            }
        },
        data(){
            const valImgUrl = (rule, value, callback) => { //视频验证
                console.log("this.DkModel.VideoCoverImgUrl",this.DkModel.VideoCoverImgUrl)
                if (!this.DkModel.VideoCoverImgUrl) {
                    callback(new Error('大咖视频封面不能为空!'));
                } else {
                    callback();
                }
            }
            const valvideo = (rule, value, callback) => { // 图片验证
                if (!this.DkModel.VideoUrl) {
                    callback(new Error('大咖视频不能为空!'));
                } else {
                    callback();
                }
            }
            return{
                rules:{
                    VideoName: [{required:true, message: '请输入观点名称！', trigger: 'change'}],
                    VideoCoverImgUrl:[{required:true,validator:valImgUrl, trigger: 'change'}],
                    VideoUrl:[{required:true,validator:valvideo, trigger: 'change'}]
                },
                // 新增大咖
                dakatitle:'',
                showdkModel:true,
                DkModel:{
                    VideoName:'',
                    VideoCoverImgUrl:'',
                    VideoUrl:'',
                    VideoSecond:0,
                    Id:0
                },
                url: apiEnv.uploadURL,
                imgLimitNum:1,
                fileList:[],
                dialogVisible:false,
                dialogImageUrl: "",     //点击查看的url
                hideUpload:false,
                fileList2:[],
                progress: 0, //进度条数据
                videoFlag:false
            }
        },
        methods:{
            // 大咖
            close(){
                this.$emit("close")
            },
            beforeAvatarUpload(file){
                const isLt2M = file.size / 1024 / 1024 < 10,
                    limitStr = ['《','》','%','#','*',";","[","]","【","】",'{','}',"&","$"],
                    bool = limitStr.find((x)=>{return file.name.indexOf(x)>-1})?false:true;
                if (!isLt2M) {
                    this.$message.error('上传图片大小不能超过 10MB!');
                }
                if(!bool){
                    this.$message.error('图片命名不得包含非法字符!');
                }
                return isLt2M && bool;
            },
            handlePicOutLimit(){
                this.$message.warning("最多只能上传一张图片哦！")
            },
            handlePictureCardPreview(file) {
                this.dialogImageUrl = "";
                this.dialogImageUrl = file.response ?
                    file.response.Data[0].imgUrl :
                    file.url;
                this.dialogVisible = true;
            },
            handleRemove(file, fileList) {
                this.DkModel.VideoCoverImgUrl = ''
                this.$refs.form.validateField(['VideoCoverImgUrl'])
                this.hideUpload = false;
                console.log(file, fileList);
            },
            successUpload(res){
                if(res.Result != 1) {
                    this.fileList = []
                    this.$refs.form.validateField('VideoCoverImgUrl');
                    return this.$message.error(res.Message)
                }
                let simageUrl =res.Data[0].imgUrl
                this.DkModel.VideoCoverImgUrl =simageUrl;
                this.$refs.form.clearValidate('VideoCoverImgUrl');
                this.hideUpload = true;
            },
            beforeAvatarUpload2(file) {
                const _this = this
                //file.size返回b单位
                const isLt10M = file.size/1024/1024/1024<10;
                if (
                    [
                        "video/mp4",
                        "video/ogg",
                        "video/flv",
                        "video/avi",
                        "video/wmv",
                        "video/rmvb",
                    ].indexOf(file.type) == -1
                ) {
                    this.$message.error("请上传正确的视频格式");
                    return false;
                }
                if (!isLt10M) {
                    this.$message.error("上传视频大小不能超过10G哦!");
                    return false;
                }
                // 获取视频时长
                var url = URL.createObjectURL(file);
                var audioElement = new Audio(url);
                var duration;
                audioElement.addEventListener("loadedmetadata", function (_event) {
                    duration = audioElement.duration; //时长为秒，小数，182.36
                    _this.DkModel.VideoSecond = parseInt(duration);
                });
            },
            Upload(file) {
                const config = {
                    region: "oss-cn-zhangjiakou",
                    accessKeyId: "LTAIm1hXML86TVS4",
                    accessKeySecret: "TsgBJS0oD3V0YBkYs6P8XnFVo0GH1O",
                    bucket: "gk-manager",
                };
                const that = this;
                async function multipartUpload() {
                    let temporary = file.file.name.lastIndexOf(".");
                    let fileNameLength = file.file.name.length;
                    let fileFormat = file.file.name.substring(
                        temporary + 1,
                        fileNameLength
                    );
                    let fileName = getFileNameUUID() + "." + fileFormat;
                    client(config)
                        .multipartUpload(`video/${fileName}`, file.file, {
                            progress: function (p) {
                                //p进度条的值
                                // console.log(p);
                                that.videoFlag = true;
                                // that.showProgress = true;
                                that.progress = Math.floor(p * 100);
                            }
                        })
                        .then(result => {
                            //上传成功返回值，可针对项目需求写其他逻辑
                            // console.log(result);
                            // console.log(result.res.requestUrls[0]);
                            that.videoFlag = false;
                            var totalUrl = result.res.requestUrls[0];
                            that.DkModel.VideoUrl=totalUrl.split("?")[0];
                        }).catch(err => {
                        that.$message.error(err)
                    });
                }
                multipartUpload();
            },
            handlePreview(file) {
            },
            // 删除文件之前的钩子
            beforeRemove(file, fileList) {
                // return this.$confirm(`确定移除 ${file.name}？`);
            },
            // 文件列表移除文件时的钩子
            handleRemove2(file, fileList) {
            },
            // 文件上传成功时的钩子
            handleSuccess(response, file, fileList) {
                this.fileList2 = fileList;
            },
            resultFormat(values) {
                var value = parseInt(values)
                var h = Math.floor(value / 3600);
                var m = Math.floor((value / 60 % 60));
                var s = Math.floor((value % 60));
                if (h < 1) {
                    h = '00'
                }
                if (m < 9) {
                    m = '0' + m
                }
                if (s < 10) {
                    s = '0' + s
                }
                return h + ':' + m + ':' + s
            },
            getQueryVariable(url, paraName) {
                var arrObj = url.split("?");
                if (arrObj.length > 1) {
                    var arrPara = arrObj[1].split("&");
                    var arr;
                    for (var i = 0; i < arrPara.length; i++) {
                        arr = arrPara[i].split("=");
                        if (arr != null && arr[0] == paraName) {
                            return arr[1];
                        }
                    }
                    return "";
                } else {
                    return "";
                }
            },
            push(formName){
                this.$refs['form'].validate((valid) => {
                    if(valid){
                        //新建或更新
                        if (this.DkModel.Id == -1) {
                            this.newMeg(-1)
                        } else {
                            this.newMeg(1)
                        }
                    }
                })
            },
            newMeg(index){
                var params = {
                    VideoUrl:this.DkModel.VideoUrl,
                    VideoSecond:this.DkModel.VideoSecond,
                    VideoName:this.DkModel.VideoName,
                    VideoCoverImgUrl:this.DkModel.VideoCoverImgUrl,
                    VideoType:2
                };
                if(index==1){
                    params.Id=this.DkModel.Id;
                }
                setuploadVideo(params).then(res=> {
                    if(res.Result != 1) {
                        return this.$message.error(res.Message)
                    }
                    this.$message.success(res.Message)
                    this.$emit("refreshList")
                })
            },
            deleteVideo(){
                let data = {
                    Id: this.DkModel.Id
                }
                deleteListVideo(data).then(res=> {
                    if(res.Result != 1) {
                        return this.$message.error('删除失败，请重新确认删除');
                    }
                    this.$message.success('删除成功！');
                    this.$emit("refreshList")
                })
            },
        },
        mounted() {
            console.log("this.currentParam",this.currentParam)
            const param = this.currentParam;
            debugger
            if(this.currentParam.Id!=-1){
                this.DkModel.VideoName = param.VideoName;
                this.DkModel.VideoCoverImgUrl = param.VideoCoverImgUrl;
                this.$nextTick(()=>{
                    // debugger
                    this.fileList = [{
                        name:'',
                        url:param.VideoCoverImgUrl
                    }]
                    if(this.fileList.length>0){
                        this.hideUpload = true;
                    }
                })
                this.DkModel.VideoUrl= param.VideoUrl;
                this.DkModel.VideoSecond=param.VideoSecond;
                this.$nextTick(()=>{
                    // debugger
                    this.fileList2 = [{
                        name:'',
                        url:param.VideoUrl
                    }]
                });
            }
            this.DkModel.Id=param.Id;
            if (param.Id==-1) {
                this.dakatitle='新增大咖观点';
            }else {
                this.dakatitle='编辑大咖观点';
            }
        }
    }
</script>

<style lang="scss">
    .Koicontent{
        .hide .el-upload--picture-card {
            display: none;
        }
        .avatar-uploader-icon {
            margin-top: 67px;
        }
        .timeDom {
            display: block;
            position: absolute;
            padding: 2px;
            color: #fff;
            top: 0;
            right: 0;
            z-index: 999;
            background: #000;

            .videoIcon2 {
                height: 18px;
                width: auto;
                vertical-align: text-bottom;
                margin-left: 5px;
            }
        }
        .avatar,
        .el-upload-dragger {
            width: 148px;
            height: 148px;
        }
        .tipsCls {
            margin-left: 10px;
        }
        .videoIcon .el-form-item__label::before {
            content: "* ";
            color: red;
        }
        .avatar-uploader-icon {
            margin-top: 67px;
        }
        .el-upload-list--text{
            display: none;
        }
        .dialog-footer{
            .el-button{
                margin: 0px 50px;
            }
        }
        .el-form-item__content{
            margin-bottom: 10px;
        }
    }

</style>
